import { LitElement, html, css, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("cg-suggestions")
export class CGSuggestions extends LitElement {
  static override styles = css`
    :host {
      --cg-font: "Inter", sans-serif;
      display: block;
      width: 100%;
      font-family: var(--cg-font);
    }

    *,
    *::before,
    *::after {
      font-family: var(--cg-font);
    }

    button {
      font: inherit;
    }

    .wrap {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-end;
      gap: 10px;
      padding: 4px 4px 2px;
    }

    button {
      padding: 10px 14px;
      border-radius: 999px;
      border: 1px solid rgba(17, 24, 39, 0.12);
      background: rgba(255, 255, 255, 0.94);
      font-family: var(--cg-font);
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      white-space: normal;
      text-align: center;
      line-height: 1.4;
      max-width: 100%;
      transition:
        background 120ms ease,
        transform 120ms ease,
        box-shadow 120ms ease;
    }

    // button:hover {
    //   background: rgba(0, 0, 0, 0.04);
    //   transform: translateY(-1px);
    // }

    button:active {
      transform: translateY(0);
      box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.05);
    }

    @media (max-width: 420px) {
      button {
        font-size: 12.5px;
        padding: 9px 12px;
      }
    }
  `;

  @property({ type: Array }) items: string[] = [];

  /** Called when a chip is clicked */
  @property({ attribute: false }) onSelect?: (value: string) => void;

  override render() {
    if (!this.items.length) return nothing;

    return html`
      <div class="wrap">
        ${this.items.map(
          (label) => html`
            <button
              @click=${() => this.onSelect?.(label)}
              aria-label=${`Suggestion ${label}`}
            >
              ${label}
            </button>
          `,
        )}
      </div>
    `;
  }
}
